import { Constant } from "../constant";
import { Injectable, Input, OnDestroy, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Subscription } from "rxjs";
import { EventManagerService } from "../service/event-manager.service";
declare let $: any;

@Injectable({ providedIn: "root" })
export class ModalBase implements OnInit, OnDestroy {
  @Input() isAddChildrenBackdrop: boolean;
  @Input() message: any;
  @Input() header: any;
  @Input() buttonLabel: any;
  @Input() buttonCancelLabel: any = "Đóng";
  @Input() func: any;
  @Input() cancelFunc: any;
  @Input() iconImage: any;
  subscriptions?: Subscription[] = [];
  Constant = Constant;

  constructor(
    public eventManagerService: EventManagerService,
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit(): void {
    if (this.isAddChildrenBackdrop) {
      this.eventManagerService.broadcast({ name: "show-backdrop-dialog" });
    }
  }
  ngOnDestroy(): void {
    if (this.isAddChildrenBackdrop) {
      this.eventManagerService.broadcast({ name: "close-backdrop-dialog" });
    }
    if (this.subscriptions.length > 0) {
      this.eventManagerService.destroys(this.subscriptions);
    }
  }
  cancel(modal) {
    this.activeModal.dismiss();
  }
  dismiss() {
    this.activeModal.dismiss();
  }
}
